import { Button } from "@hcsc-fiber/react";
import React, { useContext } from "react";
import { StateContext } from "../../context/stateContext";
import Logo from "../logo1";
import styles from "./header.module.scss";

export const languageDisplayLabel = {
  en: "English",
  es: "Español",
};

const Header = () => {
  const { languageCode, setLanguageCode } = useContext(StateContext);
  const setLanguage = () => setLanguageCode(languageCode === "en" ? "es" : "en");

  return (
    <header className={styles.header}>
      <div className={styles["header__container"]}>
        <div className={styles["header__container--left"]}>
          <Logo />
        </div>
        <div className={styles.languageButtonContainer}>
          <Button kind="tertiary" onClick={setLanguage} data-testid={`$language`}>
            {languageCode === "en" ? languageDisplayLabel.es : languageDisplayLabel.en}
          </Button>
        </div>
      </div>
    </header>
  );
};
export default Header;
